import { shallowRef, type ShallowRef } from 'vue';
import { MeetingCollection } from '@/modules/meeting/models/MeetingCollection';

export const dashboardMeetings: ShallowRef<MeetingCollection> = shallowRef(new MeetingCollection());
